module.exports = __webpack_public_path__ + "public/Icons/manage_bookings.svg?fa2ee2f8";